import { UiService } from 'modules/ui';

import './SchedulerApi';

import { LIBERATION_TYPES } from '../../../../helpers/Dripping';

import Request from '@hotmart/request';

const UNDEFINED = 'UNDEFINED';

class SchedulerService {
  request = async (url, body) => {
    try {
      await Request(url, body);

      UiService.setAlertSuccess('done');
    } catch (e) {
      UiService.setAlertError('error_try_again');
      throw e;
    }
  };

  setDrippingByDays = (value, checkedContent) => {
    const { modules, pages } = checkedContent;

    return this.request('dripping.bulk.by.days', {
      liberationDays: value,
      liberationType: LIBERATION_TYPES.BY_DAYS,
      modules,
      pages
    });
  };

  setDrippingByDate = (value, checkedContent) => {
    const { modules, pages } = checkedContent;

    return this.request('dripping.bulk.by.date', {
      liberationDate: value,
      liberationType: LIBERATION_TYPES.BY_DATE,
      modules,
      pages
    });
  };

  setExpiration = async (value, checkedContent) => {
    const { modules, pages } = checkedContent;

    if (value === UNDEFINED) {
      return this.request('delete.dripping.expiration', {
        modules,
        pages
      });
    }

    return this.request('dripping.bulk.expiration', {
      durationDays: value,
      modules,
      pages
    });
  };

  /** @type (checkedContent: CheckedContent) => ({modules: string[]; pages: string[]}) */
  removeDripping = async (checkedContent) => {
    const { modules, pages } = checkedContent;

    return this.request('delete.dripping.release', {
      modules,
      pages
    });
  };
}

export default new SchedulerService();
